import GeneralModal from 'components/SharedComponents/Modals/GeneralModal';
import { useEffect, useState } from 'react';
import type { Accept } from 'react-dropzone';

import DropzoneZone from './DropzoneZone';

type DropzoneDialogProps = {
    open: boolean;
    onClose: () => void;
    onSave: (file: File) => void;
    dropzoneText: string;
    cancelButtonText: string;
    submitButtonText: string;
    dialogTitle?: string;
    accept?: Accept;
    maxFileSize?: number;
};

const DropzoneDialog = ({
    open,
    onClose,
    onSave,
    dropzoneText,
    cancelButtonText,
    submitButtonText,
    dialogTitle = '',
    accept = undefined,
    maxFileSize = undefined,
}: DropzoneDialogProps) => {
    const [file, setFile] = useState<File | null>(null);
    const [previewSrc, setPreviewSrc] = useState<string | null>(null);

    useEffect(() => {
        if (!file) {
            setPreviewSrc(null);
            return undefined;
        }
        const url = URL.createObjectURL(file);
        setPreviewSrc(url);
        return () => URL.revokeObjectURL(url);
    }, [file]);

    const reset = () => setFile(null);

    const handleClose = () => {
        reset();
        onClose();
    };

    const handleSave = () => {
        if (!file) return;
        onSave(file);
        reset();
    };

    return (
        <GeneralModal
            isOpen={open}
            title={dialogTitle}
            onClose={handleClose}
            showCloseButton={false}
            shouldCloseOnBackdropClick
            shouldCloseOnEscape
            textButton={{ text: cancelButtonText, onClick: handleClose }}
            containedButton={{
                text: submitButtonText,
                onClick: handleSave,
                disabled: !file,
            }}
        >
            <DropzoneZone
                accept={accept}
                maxFileSize={maxFileSize}
                dropzoneText={dropzoneText}
                previewSrc={previewSrc}
                onDropAccepted={setFile}
                onRemove={reset}
            />
        </GeneralModal>
    );
};

export default DropzoneDialog;
